import { themes } from "./themes";

export function chooseTheme() {
    return themes[process.env.REACT_APP_PARTNER_NAME];
}